import Components from './../Component';
import Slider from './../components/Slider';
import ViewMore from './../components/ViewMore';

export default class Realtime extends Components {

  constructor($) {
    super($);
    this.lang = $('body').attr('data-language');
    this.timeout = null;
  }

  init(index, element) {
    this.autoload = true;
    if (this.$(element).attr('data-autoload') == 'false'){
      this.autoload = false;
    }
    if (this.autoload){
      this.get(element);
    }else{
      this.$(element).html('<a class="refresh" href="#">&nbsp;</a>');
      this.$(element).find('.refresh').on('click', function () {
        if (!this.$(element).find('.refresh').hasClass('disabled')) {
          this.get(element);
          this.$(element).find('.refresh').addClass('disabled');
        }
        return false;
      }.bind(this));
    }
  }

  get(element) {

    clearTimeout(this.timeout);
    setTimeout(function(){
      this.get(element);
    }.bind(this),15000);



    this.$.getJSON('/'+this.lang+'/bus/realtime?station=' + this.$(element).attr('data-station') + '&line=' + this.$(element).attr('data-line') + '&line_id=' + this.$(element).attr('data-line-id'), function (data) {
      this.$(element).html(data.html);
      var slider = new Slider();
      slider.$ = this.$;
      slider.init(0, this.$(element).find('.slider'));

      var view_more = new ViewMore();
      view_more.$ = this.$;
      view_more.init(0, this.$(element).find('.view-more'));

      this.$(element).find('.refresh').on('click', function () {
        if (!this.$(element).find('.refresh').hasClass('disabled')) {
          this.get(element);
          this.$(element).find('.refresh').addClass('disabled');
        }
        return false;

      }.bind(this));
    }.bind(this));
  }
}
